import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, LoginResponse } from './types';
import { persistor } from '..';
import { loginUser } from './authActions';

const initialState: AuthState = {
  loading: false,
  userInfo: null,
  userToken: null,
  tokenExpiry: null,
  error: null,
  success: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.userInfo = null;
      state.userToken = null;
      state.tokenExpiry = null;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase('PURGE', () => {
        return initialState;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, action: PayloadAction<LoginResponse>) => {
        state.loading = false;
        if (action.payload.success) {
          state.userInfo = action.payload.data.user;
          state.userToken = action.payload.data.token;
          state.tokenExpiry = action.payload.data.tokenExpiry;
          state.success = true;
          state.error = null;
        } else {
          state.error = "Login failed";
          state.success = false;
        }
      })
      .addCase(loginUser.rejected, (state, action: PayloadAction<string | undefined>) => {
        state.loading = false;
        state.error = action.payload ?? 'An unknown error occurred';
        state.userInfo = null;
        state.userToken = null;
        state.tokenExpiry = null;
        state.success = false;
      });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;